import { useQuery } from "react-query";
import { groupEvents } from "pages/api-clients/graph-search";
import { useApplicationContext } from "./useApplication";

export function useTeams(enabled = true) {
  const orgId = useApplicationContext().org_id;

  const teamsQuery = useQuery(
    ["activity-teams", { orgId }],
    async () => {
      if (!orgId) throw new Error("expected org id");
      return groupEvents(
        {
          select: ["Person"],
          groupBys: [{ target: "Team", attribute: "name" }],
          filters: [
            {
              key: "Team.name",
              target: "Team",
              attribute: "name",
              comparison: {
                "NOT IN": ["__VZBL::null__"],
              },
            },
          ],
        },
        orgId
      );
    },
    { enabled: enabled && !!orgId }
  );

  const teamSet = new Set();
  const teams = (teamsQuery.data?.data || [])
    .map((row) => ({ name: row["Team.name"] as string }))
    .filter((row) => {
      if (teamSet.has(row.name)) return false;
      teamSet.add(row.name);
      return true;
    });

  return {
    isFetched: teamsQuery.isFetched,
    isLoading: teamsQuery.isLoading,
    list: teams,
  };
}
